module.exports = __webpack_public_path__ + "static/media/15.70b6673d.jpg";